import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-delete-contact-modal",
  templateUrl: "./delete-contact-modal.component.html",
  styleUrls: ["./delete-contact-modal.component.scss"],
})
export class DeleteContactModalComponent {
  @Input() contactName = "Unknown";

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.DeleteContact;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
